export const toFixedDecimals = (num: number | string, fixed: number) => {
  var re = new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?');

  return num.toString().match(re)?.[0] ?? '0';
};
